import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import EmployeeListRequest from "../request/EmployeeListRequest";
import { EmployeeListApiResponse } from "../model/Employee";

export const EmployeeListApiService = async (request: EmployeeListRequest): Promise<EmployeeListApiResponse> => {
  const url = "/employees/";

  // Build params — map camelCase isTemporary to snake_case is_temporary for the backend
  const { isTemporary, ...rest } = request;
  const params: Record<string, unknown> = { ...rest };
  if (isTemporary !== undefined) {
    params.is_temporary = isTemporary;
  }

  const { data } = await axios.get(url, { params });
  if(data?.results) {
    return data
  }
    // Paginated & non paginated results have different return types
    return {results: data, count: data.length, pages: 0}
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useEmployeeListApiService = (request: EmployeeListRequest
) =>
  useQuery<Promise<EmployeeListApiResponse>, AxiosError, EmployeeListApiResponse>(
    ["EmployeeListApiService", ...Object.values(request)], () =>
      EmployeeListApiService(request), { keepPreviousData : true }
  );

export default useEmployeeListApiService;
